import React from 'react';
import AccountHolderDetailsPage from '../features/accountHolders/pages/AccountHolderDetailsPage';

const AccountHolderDetails: React.FC = () => <AccountHolderDetailsPage />;

export default AccountHolderDetails;
